import { createContext, useState, PropsWithChildren, useContext, useMemo, useCallback } from "react"
import { StatusBarProps } from "@shared/primitive-components"

export type UiContextType = {
  statusBar: StatusBarProps | undefined
  setStatusBar: (statusBar: StatusBarProps | undefined) => void
  dismissStatusBar: () => void
}

export const UiContext = createContext<UiContextType | undefined>(undefined)

export const UiProvider = ({ children }: PropsWithChildren<{}>) => {
  const [statusBar, setStatusBar] = useState<StatusBarProps | undefined>(undefined)
  const onSetStatusBar = useCallback((newStatusBar?: StatusBarProps) => setStatusBar(newStatusBar), [setStatusBar])
  const value = useMemo(
    () => ({
      statusBar,
      setStatusBar: onSetStatusBar,
      dismissStatusBar: () => setStatusBar(undefined),
    }),
    [statusBar, onSetStatusBar]
  )
  return <UiContext.Provider value={value}>{children}</UiContext.Provider>
}

export const useUI = () => {
  const context = useContext(UiContext)
  if (context === undefined) {
    throw new Error(`useUI must be used inside UiProvider.`)
  }
  return context
}
